import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { subscribeNewsletter, getArticles } from '../../services/api';
import { useSiteConfig } from '../../context/SiteConfigContext';
import { formatDate } from '../../utils/date';
import './Footer.css';

const SOCIAL_META = {
  facebook:  { label: 'Facebook',  color: '#1877f2', icon: <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047v-2.66c0-3.025 1.791-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.971h-1.514c-1.491 0-1.956.93-1.956 1.885v2.265h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/></svg> },
  instagram: { label: 'Instagram', color: '#e1306c', icon: <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg> },
  linkedin:  { label: 'LinkedIn',  color: '#0a66c2', icon: <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg> },
  tiktok:    { label: 'TikTok',    color: '#ff0050', icon: <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.82a4.85 4.85 0 01-1-.13z"/></svg> },
  youtube:   { label: 'YouTube',   color: '#ff0000', icon: <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg> },
  whatsapp:  { label: 'WhatsApp',  color: '#25d366', icon: <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg> },
};

export default function Footer() {
  const { t, i18n } = useTranslation('common');
  const { config } = useSiteConfig();
  const [nlEmail, setNlEmail] = useState('');
  const [nlStatus, setNlStatus] = useState(null);
  const [recentArticles, setRecentArticles] = useState([]);

  const socials = Object.entries(SOCIAL_META)
    .map(([id, meta]) => ({ id, ...meta, href: config[id] || '' }))
    .filter(s => s.href);

  useEffect(() => {
    getArticles({ limit: 3, statut: 'publie' })
      .then(data => setRecentArticles(data.articles ?? []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (nlStatus !== 'ok' && nlStatus !== 'exists') return;
    const timer = setTimeout(() => setNlStatus(null), 3000);
    return () => clearTimeout(timer);
  }, [nlStatus]);

  const handleNewsletter = async (e) => {
    e.preventDefault();
    if (!nlEmail) return;
    setNlStatus('sending');
    try {
      await subscribeNewsletter(nlEmail);
      setNlStatus('ok');
      setNlEmail('');
    } catch (err) {
      setNlStatus(err.code === 'ALREADY_SUBSCRIBED' ? 'exists' : 'error');
    }
  };

  return (
    <footer>
      <div className="foot-accent" />

      <div className="container">
        <div className="foot-top">

          {/* ── BRAND ── */}
          <div className="foot-brand">
            <img src="/logo-horizontal-white.png" alt="L'envol digital pour elles" width="700" height="280" className="foot-logo" />
            <p className="foot-desc">{t('footer.desc')}</p>
            {socials.length > 0 && (
              <div className="foot-socials">
                {socials.map((s) => (
                  <a
                    key={s.id}
                    href={s.href}
                    aria-label={s.label}
                    title={s.label}
                    className="foot-social-link"
                    style={{ '--brand': s.color }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* ── À PROPOS ── */}
          <div className="foot-col">
            <h4>{t('footer.about_title')}</h4>
            <Link to="/a-propos#projet">{t('footer.link_projet')}</Link>
            <Link to="/a-propos#vision">{t('footer.link_vision')}</Link>
            <Link to="/a-propos#theorie">{t('footer.link_theorie')}</Link>
            <Link to="/a-propos#partenaires">{t('footer.link_partenaires')}</Link>
          </div>

          {/* ── PROGRAMME ── */}
          <div className="foot-col">
            <h4>{t('footer.program_title')}</h4>
            <Link to="/cohortes">{t('footer.link_cohortes')}</Link>
            <Link to="/appel">{t('footer.link_appel')}</Link>
            <Link to="/actualites">{t('footer.link_actualites')}</Link>
            <Link to="/galerie">{t('footer.link_galerie')}</Link>
            <Link to="/contact#formulaire">{t('footer.link_contact')}</Link>
          </div>

          {/* ── ACTUALITÉS RÉCENTES ── */}
          <div className="foot-col">
            <h4>{t('footer.news_title')}</h4>
            {recentArticles.length > 0 ? (
              <>
                {recentArticles.map(a => (
                  <Link key={a.id} to={`/actualites/article/${a.slug}`} className="foot-article">
                    <span className="foot-article-title">{a.titre}</span>
                    <span className="foot-article-date">{formatDate(a.publieLe || a.creeLe, i18n.language, { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                  </Link>
                ))}
                <Link to="/actualites" className="foot-article-all">{t('footer.view_all_news')}</Link>
              </>
            ) : (
              <Link to="/actualites">{t('footer.view_news')}</Link>
            )}
          </div>

          {/* ── NEWSLETTER ── */}
          <div className="foot-col foot-col-nl">
            <h4>{t('footer.newsletter_title')}</h4>
            <p className="foot-nl-desc">{t('footer.newsletter_desc')}</p>
            {nlStatus === 'ok' ? (
              <p className="foot-nl-ok">{t('footer.newsletter_ok')}</p>
            ) : nlStatus === 'exists' ? (
              <p className="foot-nl-exists">{t('footer.newsletter_exists')}</p>
            ) : (
              <>
                <form onSubmit={handleNewsletter} className="foot-nl-form">
                  <input
                    type="email"
                    placeholder={t('footer.newsletter_placeholder')}
                    value={nlEmail}
                    onChange={(e) => setNlEmail(e.target.value)}
                    required
                  />
                  <button type="submit" disabled={nlStatus === 'sending'} aria-label={t('footer.newsletter_title')}>
                    {nlStatus === 'sending' ? '…' : '→'}
                  </button>
                </form>
                {nlStatus === 'error' && <p className="foot-nl-err">{t('footer.newsletter_error')}</p>}
              </>
            )}
          </div>
        </div>

        {/* ── BOTTOM BAR ── */}
        <div className="foot-bot">
          <span className="foot-copy">{t('footer.copyright')}</span>

          {/* <a
            href="https://www.festicsn.com/fr"
            target="_blank"
            rel="noopener noreferrer"
            className="foot-operator"
          >
            <span className="foot-operator-label">Opérateur principal</span>
            <img src="/logo-partenaire/logo_festic.png" alt="FESTIC" className="foot-operator-logo" />
            <span className="foot-operator-name">FESTIC</span>
          </a> */}

          <div className="foot-legal">
            <Link to="/mentions-legales">{t('footer.legal_mentions')}</Link>
            <Link to="/confidentialite">{t('footer.legal_confidentialite')}</Link>
            <Link to="/cookies">{t('footer.legal_cookies')}</Link>
            <Link to="/cgu">{t('footer.legal_cgu')}</Link>
          </div>
          <span className="foot-powered">
            {t('footer.powered_by')}{' '}
            <a href="https://buildingexpertsconsulting.com/" target="_blank" rel="noopener noreferrer">
              Building Experts Consulting
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
